"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
var _APCheckbox = _interopRequireDefault(require("../../../../common/APCheckbox/APCheckbox"));
require("./EnableInterestLending.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('enable-interest-confirmation');
var EnableMarginConfirmationModal = function EnableMarginConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close,
    buttonIsDisabled = _ref.buttonIsDisabled,
    submitting = _ref.submitting,
    submitForm = _ref.submitForm;
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Interest Bearing Accounts"),
    close: close,
    footer: {
      buttonType: 'submit',
      buttonText: /*#__PURE__*/_react["default"].createElement("span", null, submitting ? t("Pending") : t("Enable")),
      onClick: submitForm,
      disabled: buttonIsDisabled || submitting
    },
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('modal-header')
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: bemClasses('header')
  }, t("Are you sure you want to enable interesting bearing accounts and staking?")), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('scrollable')
  }, /*#__PURE__*/_react["default"].createElement("p", null, t("Interest bearing accounts allow the passive earning of income for crypto deposits."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('checkboxes')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
    name: "terms",
    id: "agree",
    label: t("I agree to the terms.")
  })))));
};
var _default = exports["default"] = EnableMarginConfirmationModal;